import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { CatalogRepository } from '../../../domain/repositories/catalog/catalog.repository';
import { CirculationZone, Country } from '../../../domain/interfaces/catalog/catalog.interface';
import { HttpClientService } from '../../services/http-client/http-client.service';
import { API_ENDPOINTS } from '../../config/api.config';

interface CountryDto {
  value?: string;
  label: string;
  Id: string;
}

interface CirculationZoneDto {
  label: string;
  circulation_zone: string;
  value: number;
  is_invalid: boolean;
  id: string;
}

interface CountriesResponseDto {
  countries: CountryDto[];
}

interface CirculationZonesResponseDto {
  circulation_zones: CirculationZoneDto[];
}

@Injectable()
export class CatalogRepositoryImplementation extends CatalogRepository {
  private readonly http = inject(HttpClientService);

  override getCountries(): Observable<Country[]> {
    return this.http
      .get<CountriesResponseDto>(API_ENDPOINTS.catalogs.countries)
      .pipe(map((response) => (response.data.countries ?? []).map((dto) => this.toCountry(dto))));
  }

  override getCirculationZones(): Observable<CirculationZone[]> {
    return this.http
      .get<CirculationZonesResponseDto>(API_ENDPOINTS.catalogs.circulationZones)
      .pipe(
        map((response) =>
          (response.data.circulation_zones ?? []).map((dto) => this.toCirculationZone(dto)),
        ),
      );
  }

  private toCountry(dto: CountryDto): Country {
    return { value: dto.value, label: dto.label, id: dto.Id };
  }

  private toCirculationZone(dto: CirculationZoneDto): CirculationZone {
    return {
      label: dto.label,
      circulationZone: dto.circulation_zone,
      value: dto.value,
      isInvalid: dto.is_invalid,
      id: dto.id,
    };
  }
}
